
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { FileIcon } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`File icon`}</h1>
<p>{`Used to display file like icons, to represent the file type in a visual way.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { FileIcon } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<FileIcon />`} component={FileIcon} mdxType="Playground">
  <FileIcon mdxType="FileIcon" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;